import { inject, Injectable } from '@angular/core';
import { UrlTree, Router, ActivatedRouteSnapshot } from '@angular/router';
import { StackedMessagesService } from '@shared/stacked-messages/stacked-messages.service';
import { CommonsFacade } from '@state/commons';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

@Injectable()
export class LanguagesGuard {
  private readonly router = inject(Router);
  private readonly commonsFacade = inject(CommonsFacade);
  private readonly notifService = inject(StackedMessagesService);

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    const exitUrlTree = this.router.createUrlTree(['/']);
    return this.commonsFacade.getLanguages$().pipe(
      take(1),
      map(languages => {
        if (!languages || !languages.length) {
          this.notifService.showError({ message: 'NO_LANGUAGES_EXISTING_CANT_ENTER' });
          return exitUrlTree;
        }
        return true;
      })
    );
  }
}
